(function(){
'use strict';
const C=window.AAHeadquartersClients;
if(!C?.prototype||C.prototype.__aaMultiReminders)return;
const p=C.prototype,table='aa_client_reminder_rules';
const months=['January','February','March','April','May','June','July','August','September','October','November','December'];
const state=x=>x.__aaReminderCache||(x.__aaReminderCache=new Map());
const esc=(x,v)=>x.escapeHtml(String(v??''));
const ordinal=n=>{
 const d=Number(n);
 return d+(d%100>=11&&d%100<=13?'th':({1:'st',2:'nd',3:'rd'}[d%10]||'th'));
};
const recurrenceLabel=r=>r.recurrence==='quarterly'?'Quarterly':r.recurrence==='yearly'?'Yearly':'Monthly';
const dateLabel=r=>{
 const day=ordinal(r.day_of_month||10),month=months[Number(r.start_month||1)-1]||'January';
 return r.recurrence==='yearly'?month+' '+day:
   r.recurrence==='quarterly'?month+' '+day+' start':'Every '+day;
};
const ruleList=(x,id)=>{
 const d=state(x).get(String(id));
 if(!d||d.loading)return'<p>Loading scheduled emails...</p>';
 if(d.error)return'<p role="alert">'+esc(x,d.error)+'</p>';
 if(!d.rows.length)return'<p>No scheduled emails yet. Use Add Scheduled Email to create one.</p>';
 const rows=d.rows.map(r=>{
  const category=r.category==='coop'?'Co-op':r.category==='playbook'?'Playbook':'Other';
  return '<tr class="aa-scheduled-email-row">'+
   '<td class="aa-scheduled-email-name"><strong>'+esc(x,r.reminder_name)+'</strong>'+
   '<small>'+esc(x,r.email_subject)+'</small><small>'+esc(x,category)+'</small></td>'+
   '<td>'+esc(x,recurrenceLabel(r))+'</td>'+
   '<td>'+esc(x,dateLabel(r))+'</td>'+
   '<td class="aa-scheduled-email-recipients">'+esc(x,(r.recipient_emails||[]).join(', '))+'</td>'+
   '<td><span class="aa-scheduled-email-status" data-status="'+(r.is_enabled===false?'paused':'enabled')+'">'+
     (r.is_enabled===false?'Paused':'Enabled')+'</span></td>'+
   '<td class="aa-reminder-rule__actions">'+
     '<button type="button" data-aa-reminder-rule-edit="'+esc(x,r.id)+'">Edit</button>'+
     '<button type="button" data-aa-reminder-rule-delete="'+esc(x,r.id)+'">Remove</button></td>'+
   '</tr>';
 }).join('');
 return '<table class="aa-scheduled-email-table"><thead><tr>'+
  '<th scope="col">Email</th><th scope="col">Frequency</th><th scope="col">Date</th>'+
  '<th scope="col">Recipients</th><th scope="col">Status</th><th scope="col">Actions</th>'+
  '</tr></thead><tbody>'+rows+'</tbody></table>';
};
p.renderReminderPanel=function(client){
 return '<section class="aa-client-operation-panel aa-reminder-rules" data-aa-reminder-rules="'+esc(this,client.id)+'">'+
  '<div class="aa-reminder-rules__header"><h3>Scheduled Emails</h3>'+
  '<button type="button" class="aa-button aa-button--primary" data-aa-reminder-rule-add>Add Scheduled Email</button></div>'+
  '<div data-aa-reminder-rules-list>'+ruleList(this,client.id)+'</div>'+
  '<form class="aa-reminder-editor" data-aa-reminder-editor hidden novalidate>'+
  '<h4 data-aa-reminder-heading>New Scheduled Email</h4><div class="aa-reminder-editor__grid">'+
  '<label>Email Name<input data-aa-rule="name" type="text" maxlength="140" placeholder="Playbook Reminder, 10th"></label>'+
  '<label>Purpose<select data-aa-rule="category"><option value="playbook">Playbook</option><option value="coop">Co-op</option><option value="other">Other</option></select></label>'+
  '<label>Frequency<select data-aa-rule="recurrence"><option value="monthly">Monthly</option><option value="quarterly">Quarterly</option><option value="yearly">Yearly</option></select></label>'+
  '<label>Day of Month (1–28)<input data-aa-rule="day" type="number" min="1" max="28" value="10"></label>'+
  '<label data-aa-reminder-start-month hidden>Starting Month<select data-aa-rule="month">'+
  months.map((m,i)=>'<option value="'+(i+1)+'">'+m+'</option>').join('')+'</select></label>'+
  '<label class="aa-reminder-editor__wide">Recipients (separate emails with commas)<input type="text" data-aa-rule="recipients" placeholder="owner@store.com, manager@store.com"></label>'+
  '<label class="aa-reminder-editor__wide">Subject<input data-aa-rule="subject" type="text" maxlength="240"></label>'+
  '<label class="aa-reminder-editor__wide">Message<textarea rows="5" data-aa-rule="body"></textarea></label>'+
  '</div><label class="aa-reminder-editor__enabled"><input type="checkbox" data-aa-rule="enabled" checked> Enabled</label>'+
  '<div class="aa-reminder-editor__actions"><button type="submit" class="aa-button aa-button--primary">Save Scheduled Email</button>'+
  '<button type="button" class="aa-button aa-button--secondary" data-aa-reminder-rule-cancel>Cancel</button></div>'+
  '<p data-aa-reminder-rule-feedback role="status"></p></form></section>';
};
p.__aaReminderRefreshUI=function(id){
 const host=this.root.querySelector('[data-aa-reminder-rules="'+id+'"] [data-aa-reminder-rules-list]');
 if(host)host.innerHTML=ruleList(this,id);
};
p.__aaReminderLoad=async function(id,force=false){
 if(!id)return;
 id=String(id);
 const map=state(this),prev=map.get(id);
 if(prev&&!force){if(prev.loading)return prev.promise;if(!prev.error)return;}
 const loading={loading:true,rows:prev?.rows||[],error:''};
 map.set(id,loading);
 const job=(async()=>{
  try{
   const db=window.AASupabaseClient?.getClient?.();
   if(!db)throw Error('Database unavailable.');
   const {data,error}=await db.from(table).select('*').eq('client_id',id).order('created_at',{ascending:true});
   if(error)throw error;
   if(map.get(id)!==loading)return;
   map.set(id,{loading:false,error:'',rows:Array.isArray(data)?data:[]});
  }catch(e){
   if(map.get(id)!==loading)return;
   map.set(id,{loading:false,error:e?.message||'Could not load reminders',rows:prev?.rows||[]});
  }
  this.__aaReminderRefreshUI(id);
 })();
 loading.promise=job;
 this.__aaReminderRefreshUI(id);
 return job;
};
const render=p.render;
if(typeof render==='function')p.render=function(...a){
 const result=render.apply(this,a);
 if(this.activeClientTab==='account'&&this.activeAccountSection==='reminders'&&this.activeClientId)
   void this.__aaReminderLoad(this.activeClientId);
 return result;
};
const bind=p.bindClientActions;
if(typeof bind==='function')p.bindClientActions=function(){
 bind.call(this);
 if(this.__aaReminderHandlers)return;
 this.__aaReminderHandlers=true;
 const getPanel=target=>target.closest?.('[data-aa-reminder-rules]');
 const getField=(form,k)=>form.querySelector('[data-aa-rule="'+k+'"]');
 this.root.addEventListener('change',e=>{
  if(!e.target?.matches?.('[data-aa-rule="recurrence"]'))return;
  const p=getPanel(e.target);
  const month=p?.querySelector('[data-aa-reminder-start-month]');
  if(month)month.hidden=e.target.value==='monthly';
 });
 this.root.addEventListener('click',async e=>{
  const btn=e.target.closest?.('[data-aa-reminder-rule-add],[data-aa-reminder-rule-edit],[data-aa-reminder-rule-delete],[data-aa-reminder-rule-cancel]');
  if(!btn)return;
  const panel=getPanel(btn),id=panel?.dataset.aaReminderRules;
  if(!id||String(this.activeClientId)!==String(id))return;
  e.preventDefault();
  const form=panel.querySelector('[data-aa-reminder-editor]'),field=k=>getField(form,k);
  const say=t=>{form.querySelector('[data-aa-reminder-rule-feedback]').textContent=t;};
  const all=state(this).get(id)?.rows||[];
  if(btn.hasAttribute('data-aa-reminder-rule-cancel')){form.hidden=true;return;}
  if(btn.hasAttribute('data-aa-reminder-rule-add')){
   form.reset();form.dataset.id='';field('day').value=10;field('month').value=1;
   field('recipients').value=this.getActiveClient()?.email||'';
   field('enabled').checked=true;panel.querySelector('[data-aa-reminder-start-month]').hidden=true;
   form.querySelector('[data-aa-reminder-heading]').textContent='New Scheduled Email';
   say('');form.hidden=false;field('name').focus();return;
  }
  const rule=all.find(r=>String(r.id)===String(btn.dataset.aaReminderRuleEdit||btn.dataset.aaReminderRuleDelete));
  if(!rule)return;
  if(btn.hasAttribute('data-aa-reminder-rule-edit')){
   form.dataset.id=rule.id;
   const vals={name:rule.reminder_name,category:rule.category,recurrence:rule.recurrence,day:rule.day_of_month,month:rule.start_month,recipients:(rule.recipient_emails||[]).join(', '),subject:rule.email_subject,body:rule.email_body};
   for(const [k,v]of Object.entries(vals))field(k).value=v??'';
   field('enabled').checked=rule.is_enabled!==false;
   panel.querySelector('[data-aa-reminder-start-month]').hidden=rule.recurrence==='monthly';
   form.querySelector('[data-aa-reminder-heading]').textContent='Edit Scheduled Email';
   say('');form.hidden=false;return;
  }
  if(!window.confirm('Remove scheduled email "'+rule.reminder_name+'"?'))return;
  const db=window.AASupabaseClient?.getClient?.();
  if(!db)return;
  btn.disabled=true;
  try{
   const {data,error}=await db.from(table).delete().eq('client_id',id).eq('id',rule.id).select('id');
   if(error)throw error;if(!data?.length)throw Error('Deletion not confirmed.');
   form.hidden=true;await this.__aaReminderLoad(id,true);this.showStatusMessage('Scheduled email removed.');
  }catch(err){this.showStatusMessage(err?.message||'Could not remove reminder.','error');}
  finally{if(btn.isConnected)btn.disabled=false;}
 });
 this.root.addEventListener('submit',async e=>{
  const form=e.target.closest?.('[data-aa-reminder-editor]');
  if(!form)return;
  e.preventDefault();e.stopImmediatePropagation();
  const panel=getPanel(form),id=panel?.dataset.aaReminderRules;
  if(!id||String(this.activeClientId)!==String(id))return;
  const field=k=>getField(form,k);
  const say=t=>{form.querySelector('[data-aa-reminder-rule-feedback]').textContent=t;};
  const name=field('name').value.trim(),subject=field('subject').value.trim(),body=field('body').value.trim();
  const day=Number(field('day').value),month=Number(field('month').value);
  const recipients=field('recipients').value.split(/[,;\n]/).map(x=>x.trim()).filter(Boolean);
  if(!name||!subject||!body){say('Enter a name, subject, and message for this reminder.');return;}
  if(!Number.isInteger(day)||day<1||day>28){say('Choose a date from 1 to 28.');return;}
  if(!Number.isInteger(month)||month<1||month>12){say('Choose a valid month.');return;}
  if(!recipients.length||recipients.some(v=>!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v))){
   say('Enter one or more valid recipient email addresses.');return;
  }
  const db=window.AASupabaseClient?.getClient?.();
  if(!db){say('Database unavailable.');return;}
  const payload={reminder_name:name,category:field('category').value,recurrence:field('recurrence').value,
   day_of_month:day,start_month:month,recipient_emails:[...new Set(recipients)],
   email_subject:subject,email_body:body,is_enabled:field('enabled').checked,updated_at:new Date().toISOString()};
  const ruleId=form.dataset.id||'',button=form.querySelector('button[type="submit"]');
  button.disabled=true;button.textContent='Saving...';
  try{
   const req=ruleId?db.from(table).update(payload).eq('id',ruleId).eq('client_id',id).select('id').single()
      :db.from(table).insert({...payload,client_id:id}).select('id').single();
   const {data,error}=await req;
   if(error)throw error;if(!data?.id)throw Error('Save not confirmed.');
   form.hidden=true;await this.__aaReminderLoad(id,true);
   this.showStatusMessage('Scheduled email saved.');
  }catch(err){say(err?.message||'Unable to save reminder.');}
  finally{if(button.isConnected){button.disabled=false;button.textContent='Save Scheduled Email';}}
 });
};
p.__aaMultiReminders=true;
})();